import React from 'react';
import style from '../orderItemDetail.module.scss';
import cn from 'classnames';

const DIVIDER_STYLE = { borderBottom: '2px solid #575757' };

const NutritionFacts = React.memo(({ nf }) => {
  if (!nf) {
    return (
      <div className="d-flex justify-content-center">
        No nutrition fact details available
      </div>
    );
  }
  return (
    <>
      <div
        className={cn(
          style.lineHeight10,
          style.opacity,
          'd-flex justify-content-between my-2 flex-row'
        )}
      >
        {nf.amountPerServing} Servings per container
      </div>
      <div className="fs_12">
        <div className="d-flex justify-content-between my-2 fw-600 flex-row">
          <div>Serving Size</div>
          <div>{nf.servingSize}</div>
        </div>
      </div>
      <div className={cn('my-2')} style={DIVIDER_STYLE} />
      <div className="my-2">
        <div className={cn(style.opacity, 'fw-500')}>Amount per serving</div>
        <div className={cn('d-flex justify-content-between flex-row')}>
          <div className={cn('fs_20 fw-600')}>Calories</div>
          <div
            className={cn(
              'd-flex justify-content-center align-items-center fs-22 fw-600'
            )}
          >
            {nf.calories}
          </div>
        </div>
      </div>
      <div className={cn('my-2')} style={DIVIDER_STYLE} />
      <div>
        <div
          className={cn(
            style.opacity,
            'd-flex justify-content-end text-center my-2 flex-row fs_12'
          )}
        >
          <div className="align-items-center">
            {nf.amountPerService}% Daily Value*
          </div>
        </div>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div
        className={cn(
          'd-flex justify-content-between fw-600 flex-row my-2'
        )}
      >
        <div className="col p-0">
          Total Fat{' '}
          <span className={cn(style.opacity, 'fw-100 pl-1 ')}>{nf.totalFat}g</span>
        </div>
        <div className="col p-0 d-flex justify-content-end">
          <span>{nf.totalFatPercentDaily}%</span>
        </div>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div className={cn('d-flex justify-content-between my-2 flex-row')}>
        <div className="col pr-0">
          Saturated Fat{' '}
          <span className={cn(style.opacity, 'fw-100 pl-1')}>{nf.saturatedFat}g</span>
        </div>
        <div className="col p-0 d-flex justify-content-end fw-600">
          <span>{nf.saturatedFatPercentDaily}%</span>
        </div>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div className={cn('d-flex justify-content-between my-2 flex-row')}>
        <div className="col pr-0">
          Trans Fat <span className="pl-1">{nf.transFat}g</span>
        </div>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div
        className={cn(
          'd-flex justify-content-between my-2 fw-600 flex-row'
        )}
      >
        <div className="col p-0">
          Cholesterol{' '}
          <span className={cn(style.opacity, 'fw-100 pl-1')}>{nf.cholesterol}mg</span>
        </div>
        <div className="col pr-0 d-flex justify-content-end">
          <span>{nf.cholesterolPercentDaily}%</span>
        </div>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div
        className={cn(
          'd-flex justify-content-between my-2 fw-600 flex-row'
        )}
      >
        <div className="col p-0">
          Soduim{' '}
          <span className={cn(style.opacity, 'fw-100 pl-1')}>{nf.sodium}mg</span>
        </div>
        <div className="col pr-0 d-flex justify-content-end">
          <span>{nf.sodiumPercentDaily}%</span>
        </div>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div
        className={cn(
          'd-flex justify-content-between my-2 fw-600 flex-row'
        )}
      >
        <div>
          Total Carbohydrate{' '}
          <span className={cn(style.opacity, 'fw-100 pl-1')}>
            {nf.totalCarbohydrate}g
          </span>
        </div>
        <div>{nf.totalCarbohydratePercentDaily}%</div>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div className={cn('d-flex justify-content-between my-2 flex-row')}>
        <div className="col pr-0">
          Dietary Fiber{' '}
          <span className={cn(style.opacity, 'fw-100 pl-1')}>{nf.dietaryFiber}g</span>
        </div>
        <div className="col p-0 d-flex justify-content-end fw-600">
          <span>{nf.dietaryFiberPercentDaily}%</span>
        </div>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div className={cn('d-flex justify-content-between my-2 flex-row')}>
        <div className="col pr-0">
          Total Sugars <span className="pl-1">{nf.totalSugar}g</span>
        </div>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div className={cn('d-flex justify-content-between my-2 flex-row')}>
        <div className="col pl-30">
          Includes {nf.addedSugar}g Added Sugars
        </div>
        <span>{nf.totalSugarPercentDaily}%</span>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div
        className={cn(
          'd-flex justify-content-between my-2 fw-600 flex-row'
        )}
      >
        <div className="col p-0">
          Protein <span className="fw-100 pl-1">{nf.protein}g</span>
        </div>
      </div>
      <div className={cn('my-2')} style={DIVIDER_STYLE} />
      <div className={cn('d-flex justify-content-between my-2 flex-row')}>
        <span>Vitamin D {nf.vitaminD}mcg</span>
        <span>{nf.vitaminDPercentDaily}%</span>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div className={cn('d-flex justify-content-between my-2 flex-row')}>
        <span>Calcium {nf.calcium}mg</span>
        <span>{nf.calciumPercentDaily}%</span>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div className={cn('d-flex justify-content-between my-2 flex-row')}>
        <span>Iron {nf.iron}mg</span>
        <span>{nf.ironPercentDaily}%</span>
      </div>
      <div className={cn(style.borderBottom, 'my-2')} />
      <div className={cn('d-flex justify-content-between my-2 flex-row')}>
        <span>Potassium {nf.potassium}mg</span>
        <span>{nf.potassiumPercentDaily}%</span>
      </div>
      <div className={cn('my-2')} style={DIVIDER_STYLE} />
      <div className="d-flex justify-content-between mx-2 fs-10">
        * The % Daily Value (DV) tells you how much a nutrient in a serving of
        food contributes to a daily diet. 2,000 calories a day is used for
        general nutrition advice.
      </div>
    </>
  );
});

export default NutritionFacts;
